<template>
    <div class="flex">
        <div class="flex items-center lg:gap-2 border rounded" :class="paddingSize(size)">
            <div class="flex items-center" @click="handleClick('add')">
                <slot name="add" :num="num">
                    <UButton
                        icon="i-solar-add-circle-line-duotone"
                        :padded="false"
                        variant="ghost"
                        :size="size === 'default' ? '2xl' : size"
                        aria-label="increase amount"
                    />
                </slot>
            </div>
            <div>
                <UInput
                    type="number"
                    v-model="num"
                    @change="handleInputChange"
                    variant="none"
                    aria-label="amount"
                    :ui="{ base: 'max-w-16 text-center' }"
                    :size="size === 'default' ? 'xl' : size"
                />
            </div>
            <div class="flex items-center" @click="handleClick('minus')">
                <slot name="minus" :num="num">
                    <UButton
                        icon="i-solar-minus-circle-line-duotone"
                        :padded="false"
                        variant="ghost"
                        :size="size === 'default' ? '2xl' : size"
                        aria-label="decrease amount"
                    />
                </slot>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
const num = defineModel({ default: 0 });
const props = defineProps({
    min: {
        type: Number,
        default: 1,
    },
    max: {
        type: Number,
        default: 1000,
    },
    size: {
        type: String as PropType<"xs" | "sm" | "default" | "md" | "lg" | "xl">,
        default: "default",
    },
});

function handleClick(action: "add" | "minus") {
    if (action === "add" && num.value < props.max) num.value++;
    else if (action === "minus" && num.value > props.min) num.value--;
}

function handleInputChange(e: number) {
    if (e > props.max) num.value = props.max;
    else if (e < props.min) num.value = props.min ?? 1;
}

const paddingSize = (size: string) => {
    switch (size) {
        case "xs":
            return "px-1 py-0";
        case "sm":
            return "px-1.5 py-0.5";
        case "md":
            return "px-2 py-1";
        case "lg":
            return "px-3 py-1";
        case "xl":
            return "px-4 py-2";

        default:
            return "px-4 py-1";
    }
};
</script>
